<template>
    <div class="home-page">
		<Header></Header>
		<div class="home-index">
      <div class="content crfff ac por">
        <div class="disflex mt30" style="justify-content: center;">
          <div class="home-block2 disflex" @click="getToNav('Beginner')" :class="{ disabled: level < 1 }">
            <div class="disflex" style="justify-content: center;">
              <div class="">
                <img src="../../static/images/home-img1.png">
                <div class="block2-font">
                  <div class="fw7">{{$t('Beginner')}}</div>
                  <div class="">{{$t('BeginnerTips1')}}</div>
                </div>
              </div>
            </div>
          </div>
         <div class="home-block2 disflex" @click="getToNav('Intermediate')" :class="{ disabled: level < 2 }">
            <div class="disflex" style="justify-content: center;">
              <div class="">
                <img src="../../static/images/home-img2.png">
                <div class="block2-font">
                  <div class="fw7">{{$t('Intermediate')}}</div>
                  <div class="">{{$t('IntermediateTips1')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="home-content2">
          <div class="home-block5" @click="getToNav('Advanced')" :class="{ disabled: level < 3 }">
            <img src="../../static/images/home-img3.png">
            <div class="home-block5-c disflex">
              <div class="block2-font">
                <div class="fw7">{{$t('Advanced')}}</div>
                <div class="">{{$t('AdvancedTips1')}}</div>
              </div>
              <div class="learn button" style="font-size: 25px">{{$t('Learn')}}></div>
            </div>
          </div>

          <div class="home-block5">
            <div class="book">
              <div class="book-list">
                <div class="book-item" v-for="item in book" :key="item.id" @click="goBook(item.id)">
                  <img :src="item.image" class="book-img" />
                  <div class="book-name">{{ item.name }}</div>
                </div>
              </div>
            </div>
            <div class="home-block5-c disflex" @click="getToNav('book')">
              <div class="block2-font">
                <div class="fw7">{{$t('book_title')}}</div>
                <div class="">{{$t('book_tip')}}</div>
              </div>
              <div class="learn button" style="font-size: 25px">{{$t('Learn')}}></div>
            </div>
          </div>


          <div class="home-block5" @click="getToNav('Sentences300')">
            <img src="../../static/images/home-img4.png">
            <div class="home-block5-c disflex">
              <div class="block2-font">
                <div class="fw7">{{$t('300 Sentences')}}</div>
                <div class="">{{$t('300SentencesTips1')}}</div>
              </div>
              <div class="learn button" style="font-size: 25px" >{{$t('Learn')}}></div>
            </div>
          </div>
          <div class="home-block5" @click="getToNav('Challenge')">
            <img src="../../static/images/home-img5.png">
            <div class="home-block5-c disflex">
              <div class="block2-font">
                <div class="fw7">{{$t('Basic Challenge')}}</div>
                <div class="">{{$t('BasicChallengeTips1')}}</div>
              </div>
              <div class="learn button" style="font-size: 25px">{{$t('Learn')}}></div>
            </div>
          </div>
        </div>
      </div>
		</div>
      <div class="footer mt50">
        <div class="home-bottom ac mt50">
          <div class="footer-content ac">
            <a class="crfff" href="#/faq">{{$t('FAQ')}}</a>
            <a class="crfff" href="#/termsAndCondition">{{$t('TC')}}</a>
          </div>
        </div>
        <div class="copyright">{{$t('Copyright')}}</div>
      </div>

      <Dialog ref="levelDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
        <div class="invited-c ac" slot="mdBox" style="">
          <div class="invited-l">
            <h2 class="ac mt30 font-family " style="color: #2a2d5a;font-size: 50px"> {{$t('select_level')}}</h2>
            <div style="margin-top: 20px;">
              <span  style="color: #2a2d5a;font-size: 30px">{{$t('test_level_tip')}}</span>
            </div>
            <div class="level-img-wrapper" style="margin-top: 30px;" @click="selectLevel(0)">
              <img src="../../static/images/level_chu.png" class="level-img">
              <span class="level-text font-family" style="font-size: 40px">{{$t('select_level_tip1')}}</span>
            </div>
            <div class="level-img-wrapper" style="margin-top: 30px;" @click="selectLevel(1)">
              <img src="../../static/images/level_more.png" class="level-img">
              <span class="level-text font-family" style="font-size: 40px">{{$t('select_level_tip2')}}</span>
            </div>
          </div>
        </div>
      </Dialog>



      <Dialog ref="guidanceDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
        <div class="invited-c ac" slot="mdBox" style="">
          <div class="invited-l">
            <h2 class="ac mt30 font-family " v-if="level==1" style="color: #1d188e;font-size: 50px"> {{$t('beginner_guidance_title')}}</h2>
            <h2 class="ac mt30 font-family " v-if="level==2"  style="color: #1d188e;font-size: 50px"> {{$t('intermediate_guidance_title')}}</h2>
            <h2 class="ac mt30 font-family " v-if="level==3"  style="color: #1d188e;font-size: 50px"> {{$t('advance_guidance_title')}}</h2>
            <div class="level-img-wrapper" style="margin-top: 30px;width: 60%" >
              <img v-if="level==1" src="../../static/images/beginner_class.png" class="level-img">
              <img v-if="level==2" src="../../static/images/intermediate_class.png" class="level-img">
              <img v-if="level==3" src="../../static/images/advance_class.png" class="level-img">
            </div>
            <div style="margin-top: 20px;">
              <span v-if="level==1" style="color: #1d188e;font-size: 30px">{{$t('beginner_guidance_tip')}}</span>
              <span v-if="level==2" style="color: #1d188e;font-size: 30px">{{$t('intermediate_guidance_tip')}}</span>
              <span v-if="level==3" style="color: #1d188e;font-size: 30px">{{$t('advance_guidance_tip')}}</span>
            </div>
          </div>
          <div class="modal-footer ac" >
            <div class="sig" >
              <button style="font-size: 30px" class="btn btn-blue" @click="close_level_guidance">{{$t('OK')}}</button>
            </div>
          </div>
        </div>
      </Dialog>


      <!--签到奖励-->
      <Dialog ref="dailyDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
        <div class="invited-c ac" slot="mdBox" style="">
          <div class="invited-l">
            <h2 class="ac mt30 font-family " style="color: #1d188e;font-size: 50px;font-weight: 900"> {{$t('sign_pop_up_title')}}</h2>

            <div class="level-img-wrapper" style="margin-top: 30px;width: 60%" >
              <img  src="../../static/images/sign_prize_pic.png" class="level-img">
            </div>
            <div style="margin-top: 20px;">
              <span  style="color: #1d188e;font-size: 30px">{{$t('sign_tip')}}</span>
            </div>
          </div>
          <div class="modal-footer ac" >
            <div class="sig" >
              <button style="font-size: 30px;font-weight: 200" class="btn btn-blue" @click="getToNav('DailyLogin')">{{$t('sign_in')}}</button>
            </div>
          </div>
        </div>
      </Dialog>



    </div>



</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'

export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        isShow:null,
        isEN:'bur',
        levelModal:false,
        level:0,
        book:[],
        isSign:true,
      }
    },
	created(){
    this.isEN = localStorage.getItem('lang')
    this.getUserLevel();
    this.get_book();
	},
    methods: {
      getToNav(url){
        if (url === 'Intermediate' && this.level < 2) {
          this.$utils.alertText(this.$t('Intermediate_tips'),80,2000);
          return;
        }
        if (url === 'Advanced' && this.level < 3) {
          this.$utils.alertText(this.$t('Advanced_tips'),80,2000);
          return;
        }
        this.$router.push({path:'/'+url});
      },
      getUserLevel(){
        let that =this;
        that.$parent.loadModal(true);
        that.$api.post('/api/level/info',null,r =>{
          that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            that.level = r.data.level;
            if (r.data.level == 0){
              that.$refs.levelDialog.showMaskFun();
            }
            let is_guidance = localStorage.getItem('is_guidance')
            that.isSign = r.data.is_sign
            if(!r.data.is_sign && is_guidance){
              // that.$refs.dailyDialog.showMaskFun();
            }
            that.pop_up_level_guidance();

          });

        })
      },
      selectLevel(level) {
        // 关闭弹窗
        this.$refs.levelDialog.closeMask();
        let that =this;
        if (level >=1){
          that.$parent.loadModal(true);
          that.$api.post('/api/level/update', {'level':level},r =>{
            that.$parent.returnCode(r,function(){
              that.$parent.loadModal(false);
              that.level = r.data.level;
              that.pop_up_level_guidance();
            });
          })
        }else {
          that.$router.push({path:'/leveltest'});
        }
      },
      get_book() {
        let that =this;
        that.$parent.loadModal(true);
        that.$api.post('/api/book/list', {},r =>{
          that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            that.book = r.data;
          });
        })
      },
      goBook(id) {
        this.$router.push({ path: '/BookDetail?id=' + id })
      },
      pop_up_level_guidance(){
        let that =this;
        let is_guidance = localStorage.getItem('is_guidance')
        if (!is_guidance && that.level >=1){
          that.$refs.guidanceDialog.showMaskFun();
          localStorage.setItem('is_guidance',true)
        }
      },
      close_level_guidance(){
        let that =this;
        that.$refs.guidanceDialog.closeMask();
        if(!that.isSign){
          // that.$refs.dailyDialog.showMaskFun();
        }
      },

	}
}
</script>
<style scoped>

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.disabled {
  //pointer-events: none; /* 禁止点击 */
  opacity: 0.5;         /* 半透明置灰 */
  filter: grayscale(100%); /* 灰色效果 */
}

.level-img-wrapper {
  position: relative;
  width: 90%;
  margin: 0 auto;
}

.level-img {
  width: 100%;
  display: block;
}

.level-text {
  position: absolute;
  top: 60%;       /* 垂直居中 */
  left: 35%;      /* 水平居中 */
  transform: translate(-50%, -50%);
  color: #fff;    /* 根据图片调整文字颜色 */
  font-size: 24px;
  text-align: center;
  font-weight: bold;
}

/* book样式 */
.book {
  overflow-x: auto;
  white-space: nowrap;
  padding: 20px 0; /* 上下间距 */
}

.book-list {
  display: flex;
  flex-direction: row;
  padding: 0 20px; /* 左右留白 */
}

.book-item {
  flex: 0 0 auto;
  width: 180px;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s;
  margin-right: 10px;  /* 👈 控制和 Sentences300 一样的横向间距 */
}

.book-item:last-child {
  margin-right: 0; /* 最后一个不要多余空隙 */
}

.book-img {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}

.book-name {
  margin-top: 10px;
  font-size: 22px;
  font-weight: bold;
  color: #333;
  white-space: normal;
}


</style>



// WEBPACK FOOTER //
// src/page/index.vue